import CitySEOHead from "@/components/feature/CitySEOHead";
import BonitaSpringsHeroSection from "./components/HeroSection";
import BonitaSpringsStickyNav from "./components/StickyNav";
import BonitaSpringsProcessingTimeSection from "./components/ProcessingTimeSection";
import BonitaSpringsServicesSection from "./components/ServicesSection";
import BonitaSpringsLocalAreaSection from "./components/LocalAreaSection";
import BonitaSpringsTravelTimingSection from "./components/TravelTimingSection";
import BonitaSpringsDestinationsSection from "./components/DestinationsSection";
import BonitaSpringsTestimonialsSection from "./components/TestimonialsSection";
import BonitaSpringsAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import BonitaSpringsComparisonSection from "./components/ComparisonSection";
import BonitaSpringsMistakesSection from "./components/MistakesSection";
import BonitaSpringsHowItWorksSection from "./components/HowItWorksSection";
import BonitaSpringsFAQSection, { faqs } from "./components/FAQSection";
import BonitaSpringsHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import BonitaSpringsFinalCTA from "./components/FinalCTA";

const pageTitle = "Emergency Passport Bonita Springs, FL — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Bonita Springs, FL — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Southwest Florida travelers.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function BonitaSpringsPage() {
  return (
    <>
      <CitySEOHead
        city="Bonita Springs"
        state="Florida"
        stateAbbr="FL"
        route="/bonita-springs"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Bonita Springs, Florida"
        geoPosition="26.3398;-81.7787"
        keywords="expedited passport Bonita Springs, emergency passport Bonita Springs FL, same day passport Bonita Springs, fast passport Florida, passport renewal Bonita Springs, Southwest Florida passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
        lastModified="2026-06-09"
        serviceAreaDesc="Fast Passport Center does not have a physical office in Bonita Springs — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours for Bonita Springs and Southwest Florida travelers."
      />

      <div className="font-sans">
        <BonitaSpringsHeroSection />
        <BonitaSpringsStickyNav />
        <BonitaSpringsProcessingTimeSection />
        <BonitaSpringsServicesSection />
        <BonitaSpringsLocalAreaSection />
        <BonitaSpringsTravelTimingSection />
        <BonitaSpringsDestinationsSection />
        <BonitaSpringsTestimonialsSection />
        <BonitaSpringsAcceptanceFacilitiesSection />
        <BonitaSpringsComparisonSection />
        <BonitaSpringsMistakesSection />
        <BonitaSpringsHowItWorksSection />
        <BonitaSpringsFAQSection />
        <BonitaSpringsHelpfulResourcesSection />
        <BonitaSpringsFinalCTA />
      </div>
    </>
  );
}